import { LanguageLocale } from '@/model/language-locale';
import { nextTick, ref } from 'vue';
import { createI18n } from 'vue-i18n';
import config from '@/config';

export const LS_LOCALE_KEY = 'ms-locale';

export const DEFAULT_LOCALE: LanguageLocale = 'en';

export const i18n = createI18n({
  locale: DEFAULT_LOCALE,
  legacy: false,
  globalInjection: true,
  fallbackLocale: false,
  flatJson: true,
});

const loadedLocales: { [key: string]: boolean } = {};

export const useI18n = (initialLocale?: LanguageLocale) => {
  const localeRef = ref<LanguageLocale>(initialLocale || DEFAULT_LOCALE);

  const setI18nLanguage = (locale: LanguageLocale) => {
    localStorage.setItem(LS_LOCALE_KEY, locale);
    if (locale === i18n.global.locale.value) {
      return;
    }

    i18n.global.locale.value = locale;

    document.querySelector('html')?.setAttribute('lang', locale);
  };

  const loadLocaleMessages = async (locale: LanguageLocale) => {
    if (loadedLocales[locale]) {
      return;
    }

    const messages = await fetch(
      `${config.VUE_APP_TRANSLATIONS_URL}/${locale}.json?release=${process.env.VUE_APP_VERSION}`
    ).then(res => res.json());

    i18n.global.setLocaleMessage(locale, messages);

    loadedLocales[locale] = true;

    return nextTick();
  };

  const switchLocale = async (locale: LanguageLocale) => {
    await loadLocaleMessages(locale);
    setI18nLanguage(locale);
    localeRef.value = locale;
  };

  return {
    switchLocale,
    locale: localeRef,
  };
};
